import styled from "styled-components";

export const ModalContent = styled.div`
    position: relative;
    display: grid;
    grid-template-rows: auto 1fr;
    gap: 24px;
    overflow: hidden;
    max-height: calc(90vh - 32px);
    width: 100%;
    padding: 4px 0 0;

    @media (max-width: 480px) {
        gap: 16px;
    }
`;

export const ButtonCloseModal = styled.button`
    position: absolute;
    top: 0;
    right: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;
    flex-shrink: 0;
    background: none;
    border: none;
    padding: 0;
    border-radius: 4px;
    opacity: 0.7;
    transition: opacity 0.2s;
    z-index: 1;
    &:hover {
        cursor: pointer;
        opacity: 1;
    }
`;

export const ModalTitle = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    gap: 4px;
    flex-shrink: 0;
    padding-right: 36px;

    h1 {
        font-size: 18px;
        font-weight: 600;
        line-height: 1.25;
        color: ${({ theme }) => theme.colors.interfaceText500};
    }

    p {
        font-size: 14px;
        font-weight: 400;
        line-height: 1.4;
        color: ${({ theme }) => theme.colors.interfaceText300};
        text-align: left;
    }
`;

export const ModalFormScroll = styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    padding-right: 4px;
    scrollbar-width: thin;
    scrollbar-color: ${({ theme }) => theme.colors.interfaceGray300} ${({ theme }) => theme.colors.background};

    &::-webkit-scrollbar {
        width: 8px;
    }
    &::-webkit-scrollbar-track {
        background: ${({ theme }) => theme.colors.interfaceText200};
        border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb {
        background: ${({ theme }) => theme.colors.interfaceGray300};
        border-radius: 4px;
    }
`;

export const FormField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
`;

export const FormRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    margin-bottom: 16px;
    align-items: start;

    /* Garante que labels na mesma linha tenham altura igual para alinhar os inputs */
    ${FormField} .title {
        min-height: 2.6em;
    }

    @media (max-width: 480px) {
        grid-template-columns: 1fr;
    }
`;

export const FormRowThree = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 12px;
    margin-bottom: 16px;

    @media (max-width: 600px) {
        grid-template-columns: 1fr;
    }
`;

export const ModalForm = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    width: 100%;
    margin: 0;

    .input-full {
        width: 100%;
        margin-bottom: 16px;
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: stretch;
    }

    .input-full label,
    .input-full input,
    .input-full textarea {
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
    }

    .input-full label.title {
        min-height: 0;
        display: block;
        flex-shrink: 0;
    }

    .input-full input {
        height: 48px;
    }

    /* Alinha input de créditos com o select de modo de precificação (mesma altura e topo) */
    ${FormField} .default-input {
        min-height: 0;
    }
    ${FormField} .default-input input {
        height: 48px;
        margin-top: 0;
        box-sizing: border-box;
        border-radius: 4px;
    }

    .input-full textarea {
        min-height: 80px;
        padding: 10px 12px;
        border: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
        border-radius: 6px;
        font-size: 14px;
        font-family: inherit;
        resize: vertical;
    }

    .input-full textarea.error {
        border-color: ${({ theme }) => theme.colors.primaryRed400};
    }

    .input-full .title,
    ${FormField} .title {
        font-size: 12px;
        font-weight: 500;
        text-transform: uppercase;
        letter-spacing: 0.02em;
        color: ${({ theme }) => theme.colors.interfaceText400};
    }

    .input-full .title span,
    ${FormField} .title span {
        color: ${({ theme }) => theme.colors.primaryRed400};
    }

    /* Mantém o texto do label na cor normal (só o asterisco * fica vermelho) */
    ${FormField} .title .label-text {
        color: ${({ theme }) => theme.colors.interfaceText400};
    }
    ${FormField} .title .label-text span {
        color: ${({ theme }) => theme.colors.primaryRed400};
    }

    ${FormField} .hint {
        font-size: 13px;
        color: ${({ theme }) => theme.colors.interfaceText300};
    }

    .input-full:last-of-type {
        margin-bottom: 0;
    }

    .error-msg {
        color: ${({ theme }) => theme.colors.primaryRed400};
        font-size: 12px;
        margin-top: 2px;
        display: block;
    }

    ${FormField} .error-msg {
        margin-top: 2px;
    }

    .label-help {
        cursor: help;
    }

    .hint-block {
        font-size: 13px;
        margin-top: 2px;
        display: block;
    }

    .hint-loading {
        display: block;
        margin-bottom: 12px;
    }

    .error-msg-block {
        display: block;
        margin-bottom: 12px;
    }

    .toggle-disabled {
        cursor: not-allowed !important;
        opacity: 0.55;
        filter: grayscale(0.4);
    }

    .toggle-row-readonly .label,
    .toggle-row-readonly .hint {
        color: ${({ theme }) => theme.colors.interfaceText300 || '#9CA3AF'};
        opacity: 0.85;
    }

    .toggle-tooltip-wrap {
        display: inline-flex;
        flex-shrink: 0;
        width: fit-content;
    }

    .toggle-disabled-wrap {
        display: inline-flex;
        cursor: not-allowed;
    }
`;

export const ToggleRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 10px;
    margin-bottom: 16px;
    background: ${(props: any) => props.theme.colors.cfafcfd};
    border: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
    border-radius: 8px;
`;

export const ToggleTrack = styled.button<{ $on: boolean }>`
    position: relative;
    width: 44px;
    height: 24px;
    border-radius: 12px;
    border: none;
    cursor: pointer;
    padding: 0;
    flex-shrink: 0;
    background: ${({ theme, $on }) =>
        $on ? theme.colors.primaryRed400 : theme.colors.interfaceBorder100};
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
`;

export const ToggleThumb = styled.span<{ $on: boolean }>`
    position: absolute;
    top: 2px;
    left: ${({ $on }) => ($on ? 22 : 2)}px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: ${(props: any) => props.theme.colors.white};
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(0, 0, 0, 0.08);
    transition: left 0.2s ease;
`;

export const ToggleLabelWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;

    .label {
        font-size: 12px;
        font-weight: 500;
        text-transform: uppercase;
        letter-spacing: 0.02em;
        color: ${({ theme }) => theme.colors.interfaceText400};
    }

    .hint {
        font-size: 13px;
        color: ${({ theme }) => theme.colors.interfaceText300};
    }
`;

export const SelectWrap = styled.div`
    min-height: 48px;
`;

export const ButtonRow = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    margin-top: 8px;
    width: 100%;
    justify-content: flex-end;

    @media (max-width: 480px) {
        flex-direction: column;
        gap: 12px;
    }
`;

export const ModalButtonCancel = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 100px;
    height: 40px;
    padding: 0 16px;
    border-radius: 6px;
    border: 1px solid ${({ theme }) => theme.colors.interfaceGray200};
    background: ${({ theme }) => theme.colors.interfacePure0};
    color: ${({ theme }) => theme.colors.interfaceText500};
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        background: ${({ theme }) => theme.colors.interfacePure100};
        border-color: ${({ theme }) => theme.colors.interfaceGray300};
    }

    @media (max-width: 480px) {
        width: 100%;
        min-width: 0;
    }
`;

export const ModalButtonPrimary = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 100px;
    height: 40px;
    padding: 0 16px;
    border-radius: 6px;
    border: none;
    background: ${({ theme }) => theme.colors.primaryRed400};
    color: ${(props: any) => props.theme.colors.pureWhite};
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;

    &:hover:not(:disabled) {
        opacity: 0.9;
    }

    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }

    @media (max-width: 480px) {
        width: 100%;
        min-width: 0;
    }
`;
